import React from "react";
import { useObserver } from "mobx-react";
import {
  FormControl,
  Input,
  TextField,
  MenuItem,
  Select,
  Typography
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import locale from "@bonliva-crm/locale";
import { DocumentUploaderDialog } from "@containers/DocumentUploader/DocumentUploaderDialog";

type Expiration = "week" | "month" | "year";

export type SharedFile = {
  id: string;
  file: File;
  name: string;
  expiration: Expiration;
};

type Props = {
  files: SharedFile[];
  onClose: () => void;
  onUpload: () => Promise<any>;
  onChangeExpiration: (fileId: string, exp: Expiration) => void;
  onChangeName: (fileId: string, name: string) => void;
};

export function SharedFileUploader(props: Props) {
  const classes = useStyles({});

  return useObserver(() => {
    const isValid = props.files.filter((x) => !x.name.trim()).length === 0;

    return (
      <DocumentUploaderDialog
        canSubmit={isValid}
        files={props.files.map((x) => x.file)}
        onClose={props.onClose}
        onUpload={props.onUpload}
        renderInitial={(docList) => {
          return (
            <div>
              <div className={classes.message}>
                <Typography>{locale.SetNameAndExpiration}</Typography>
              </div>

              {props.files.map((file) => {
                const error = !file.name.trim();

                return (
                  <div className={classes.fileRow} key={file.id}>
                    <TextField
                      error={error}
                      className={classes.fileName}
                      label={locale.FileName}
                      value={file.name}
                      onChange={(e) => props.onChangeName(file.id, e.target.value)}
                    />

                    <FormControl>
                      {/*<InputLabel shrink htmlFor="expirationDate">*/}
                      {/*  {locale.ExpiresFromNow} {new Date().toDateString()}*/}
                      {/*</InputLabel>*/}

                      <Select
                        className={classes.exp}
                        id="expirationDate"
                        autoWidth
                        displayEmpty
                        input={
                          <Input
                            name="expirationDate"
                            id="expirationDate"
                            style={{ textAlign: "right" }}
                          />
                        }
                        onChange={(e, v) =>
                          props.onChangeExpiration(file.id, e.target.value as Expiration)
                        }
                        value={file.expiration}
                        data-test="ExpirationDateSelect"
                      >
                        <MenuItem value="week">{label(locale.Week)}</MenuItem>
                        <MenuItem value="month">{label(locale.Month)}</MenuItem>
                        <MenuItem value="year">{label(locale.Year)}</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                );
              })}
            </div>
          );
        }}
      />
    );
  });
}

const useStyles = makeStyles(() => ({
  message: { marginBottom: 8 },

  fileRow: {
    display: "flex",
    alignItems: "flex-end"
  },

  fileName: {
    flex: 1,
    marginRight: 8,
    marginTop: 8
  },

  exp: {
    flex: "0 0 auto",
    width: "8rem"
  }
}));

function label(v) {
  return `1 ${v.toLocaleLowerCase()}`;
}
